import { render } from "./ModelDetails.vue?vue&type=template&id=fb896824&scoped=true"
import script from "./ModelDetails.vue?vue&type=script&lang=js"
export * from "./ModelDetails.vue?vue&type=script&lang=js"

import "./ModelDetails.vue?vue&type=style&index=0&id=fb896824&scoped=true&lang=css"
import "./ModelDetails.vue?vue&type=style&index=1&id=fb896824&lang=css"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb896824"]])

export default __exports__